import axios from 'axios';
import Cookies from 'js-cookie';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_SERVER
});

class Api {

  static post = (command, params = {}) => {
    // 쿠키에서 특정 값을 읽어옵니다.
    const utk = Cookies.get('utk');
    // 헤더 객체 초기화
    let headers = {};

    // 'utk' 값이 존재할 경우에만 헤더에 추가합니다.
    if (utk) {
      headers['utk'] = utk;
    }

    const data = { ...params, command: command };
    return apiClient.post('/ajax', data, { headers });
  }


  static postFileUpload = async (command, params={}, selectedFile) => {
    if (selectedFile) {
    
      const formData = new FormData();
      formData.append('command', command);
      Object.keys(params).forEach(key => {
        formData.append(key, params[key]);
      });
      formData.append('file', selectedFile);

      // 쿠키에서 특정 값을 읽어옵니다.
      const utk = Cookies.get('utk');
      // 헤더 객체 초기화
      let headers = {'Content-Type': 'multipart/form-data'};

      // 'utk' 값이 존재할 경우에만 헤더에 추가합니다.
      if (utk) {
        headers['utk'] = utk;
      }
      
      return apiClient.post('/api', formData, { headers:headers });
    }
  };

  
  static enteranceMediaScan = () => Api.post('enteranceMediaScan');
  static hpProductScan = () => Api.post('hpProductScan');

  static hpSellingScan = () => Api.post('hpSellingScan');


}

export default Api;

